import { api } from '../configs/apiConfig';

class XPortionService {
  // Get all X-Portion entries
  async getAll() {
    try {
      const response = await api.get('/xportion');
      return response.data;
    } catch (error) {
      console.error('Error fetching X-Portion values:', error);
      throw error;
    }
  }

  // Get a specific X-Portion by ID
  async getById(id) {
    try {
      const response = await api.get(`/xportion/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching X-Portion:', error);
      throw error;
    }
  }

  // Get the latest X-Portion value
  async getLatest() {
    try {
      const response = await api.get('/xportion/latest');
      console.log('Latest X-Portion from API:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching latest X-Portion:', error);
      return { value: 1.0, dateTime: new Date().toISOString() }; // Default value if request fails
    }
  }

  // Create a new X-Portion entry
  async create(xPortionData) {
    try {
      const response = await api.post('/xportion', xPortionData);
      return response.data;
    } catch (error) {
      console.error('Error creating X-Portion:', error);
      throw error;
    }
  }

  // Update an existing X-Portion entry
  async update(id, xPortionData) {
    try {
      const response = await api.put(`/xportion/${id}`, xPortionData);
      return response.data;
    } catch (error) {
      console.error('Error updating X-Portion:', error);
      throw error;
    }
  }

  // Delete an X-Portion entry
  async delete(id) {
    try {
      const response = await api.delete(`/xportion/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting X-Portion:', error);
      throw error;
    }
  }
}

export default new XPortionService(); 